import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';
import { RepairLineItemsForm, RepairLineItemsFormBulk } from '../form-model/damage-and-repair.form.model';
import { PartExclusionRule } from '../models/part-exclusion-rule.model';

const errorKey = 'mutualExclusivePart';

function updateLineConflict(lineItem: AbstractControl, lineConflict?: string): void {
  const errors = { ...lineItem.errors };
  if (lineConflict) {
    errors[errorKey] = { value: lineConflict };
  } else {
    delete errors[errorKey];
  }
  if (lineItem.hasError(errorKey) || lineConflict) {
    lineItem.setErrors(Object.keys(errors).length ? errors : null, { emitEvent: false });
  }
}

export function mutualExclusivePartValidator(exclusions: PartExclusionRule[]): ValidatorFn {
  const excludedByPart = new Map<string, Set<string>>();
  for (const { partNumber, excludedPartNumber } of exclusions) {
    if (!excludedByPart.has(partNumber)) excludedByPart.set(partNumber, new Set());
    if (!excludedByPart.has(excludedPartNumber)) excludedByPart.set(excludedPartNumber, new Set());
    excludedByPart.get(partNumber)!.add(excludedPartNumber);
    excludedByPart.get(excludedPartNumber)!.add(partNumber);
  }

  return (control: AbstractControl) => {
    const lineItems = (control as FormGroup<RepairLineItemsForm | RepairLineItemsFormBulk>).controls.repairLineItems.controls;
    const previousParts: string[] = [];
    let firstConflict: string | undefined;

    for (const lineItem of lineItems) {
      let lineConflict: string | undefined;
      for (const part of lineItem.controls.parts.controls) {
        const partNumber = part.controls.partNumber.value;
        if (!partNumber) continue;
        const conflictingPart = previousParts.find((previous) => excludedByPart.get(partNumber)?.has(previous));
        if (conflictingPart && !lineConflict) {
          lineConflict = `Parts ${conflictingPart} and ${partNumber} cannot be added in the same work order. Choose one or the other.`;
          firstConflict ??= lineConflict;
        }
        previousParts.push(partNumber);
      }

      updateLineConflict(lineItem, lineConflict);
    }

    return firstConflict ? { [errorKey]: { value: firstConflict } } : null;
  };
}
